import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-A1-logo_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 44.8 30.4"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-A1-logo_svg__cls-1{fill:#062027}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "m27.5 13.1 8.4.4c2.1 0 2.1 3.1-.1 3.1l-8.3.4-7.7 13.4h12.5L44.8 0H19.9l7.6 13.1Z",
      class: "svg-A1-logo_svg__cls-1"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "m14 16.7-2.2 2.8H9.3l1.3-4.3-1.3-4.3h2.5l2.2 2.8 6.9-.4L16.7 0h-3.8S.2 30 0 30.4h16.6L21 17.1l-7-.4Z",
      class: "svg-A1-logo_svg__cls-1"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "A1-logo"}) } }